import React from 'react'
import _ from 'lodash'
import { NavigationButton, AccordianDropDownList, InformationBanner } from '../../Shared'
import { CompleteMsgHome, OnboardingDataCard } from '../components'
import { teacher_selfStartPath, teacher_studentStartPath } from './data'

import '../../../assets/scss/components/OnboardingHomepage/eduator-homepage.css'
import '../../../assets/scss/components/OnboardingHomepage/onboarding-section-container.css'

import { OnboardingTeacherContext } from '../../../contexts/OnboardingTeacherContextProvider'
import { useOnboardingUtils } from '../useOnboardingUtils'
import { status, step_id } from '../onboardingUtils'

//for list component
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
library.add(faCheckCircle)

/* This component is the onboarding page for educators - contains two sections
    - [x] Display info for Get yourself familiar first section
    - [x] Display info for Get your students started section
    
    **Functionalities/endpoints to be determined
*/

const EducatorHomepage = () => {
    const { teacherStartTrack, studentStartTrack, isAllComplete, setActiveKeyList } = React.useContext(OnboardingTeacherContext)

    /*on rendering onboarding home page, set all of the steps to 
    collapse and set ONLY in-progress step to be expanded*/
    React.useEffect(() => {
        setActiveKeyList([...(_.values(teacherStartTrack.steps).map(value => value === _.indexOf(status, 'inProgress'))),
        ...(_.values(studentStartTrack.steps).map(value => value === _.indexOf(status, 'inProgress')))])
    }, [])

    return (
        <div>
            <ul className="Home-educator_onboarding">
                <li>
                    <section className="onboarding-section">
                        <h2 className="onboarding-section-title"> Get yourself familiar first </h2>
                        <ul className='AccordianDropdown-list'>
                            {step_id.map((data, index) => {
                                return index < _.size(teacher_selfStartPath) &&
                                    (
                                        <AccordianDropDownList
                                            listHead={<ListHead title={teacher_selfStartPath[data].mainTitle} currStatus={teacherStartTrack.steps[teacher_selfStartPath[data].contextValue]} />}
                                            listData={<ListData data={teacher_selfStartPath[data]} step_id={index} pathName='teacher_selfStartPath' />}
                                            key={index}
                                            activeIndex={index}
                                            context={OnboardingTeacherContext}
                                            isDisable={teacherStartTrack.steps[teacher_selfStartPath[data].contextValue] === _.indexOf(status, 'disabled')}
                                        />
                                    )
                            })}
                        </ul>
                    </section>
                </li>
                <li>
                    <section className="onboarding-section">
                        <h2 className="onboarding-section-title"> Get your students started </h2>
                        <ul className='AccordianDropdown-list'>
                            {step_id.map((data, index) => {
                                return index >= _.size(teacher_selfStartPath) && (
                                    <AccordianDropDownList
                                        listHead={<ListHead title={teacher_studentStartPath[data].mainTitle} currStatus={studentStartTrack.steps[teacher_studentStartPath[data].contextValue]} />}
                                        listData={<ListData data={teacher_studentStartPath[data]} step_id={index} pathName='teacher_studentStartPath' />}
                                        key={index}
                                        activeIndex={index}
                                        context={OnboardingTeacherContext}
                                        isDisable={studentStartTrack.steps[teacher_studentStartPath[data].contextValue] === _.indexOf(status, 'disabled')}
                                    />
                                )
                            })}
                        </ul>
                    </section>
                </li>
                {isAllComplete && <li><CompleteMsgHome /></li>}
            </ul>
        </div>
    )
}

//ListHead & ListData should be displayed inside of AccordianDropDownList
const ListHead = ({ title, currStatus }) => {
    //status should be determined with completion checks
    currStatus = {
        isDisable: [_.indexOf(status, 'disabled'), _.indexOf(status, 'advancedCompletion')].includes(currStatus),
        isComplete: [_.indexOf(status, 'completed'), _.indexOf(status, 'advancedCompletion')].includes(currStatus)
    }

    return (
        <div className={`AccordianDropdown-listHead${currStatus.isDisable ? "_disable" : ""}`}>
            <h3 className={`AccordianDropdown-listHead-title${currStatus.isDisable ? "_disable" : ""}`}>{title}</h3>
            {currStatus.isComplete ? <FontAwesomeIcon className='AccordianDropdown-listHead-check' icon={faCheckCircle} /> : null}
        </div>
    )
}

const ListData = ({ data, step_id, pathName }) => {
    /* using dangerouslySetInnerHTML,it is the same as .innerHTML in plain JS. One should
   not use this injection method with data coming from any third party source without
   first sanitizing the data for security. In this case, data comes purely from 
   internal data.js which are all text stored in object form, and there is no user input 
   at any point*/

    const { handleTaskSkip, handlePathChange } = useOnboardingUtils()

    return (
        <React.Fragment>
            {data.mainText && <p dangerouslySetInnerHTML={{ __html: data.mainText }}></p>}
            {data.mainContent?.map((sectionContent, index) => {
                return <div className='onboardingDataView-container' key={"onboardingDataContainer" + index}>
                    {sectionContent.map((content, index) => {
                        return <OnboardingDataCard key={'onboardingDataCard-' + data.contextValue + index} content={content} />
                    })}
                </div>
            })
            }

            <InformationBanner>
                <p dangerouslySetInnerHTML={{ __html: data.bannerContent }}></p>
                <div className='informationBanner-actionable'>
                    {
                        data.actions && data.actions.map((action, index) => {
                            return <NavigationButton
                                key={action.text + index}
                                message={action.text}
                                actionType={action.actionType}
                                actionFunction={() => {
                                    if (action.actionType === 'button') {
                                        handlePathChange(pathName)
                                        handleTaskSkip(step_id)
                                    }
                                    else if (action.actionType === 'link') {
                                        handlePathChange(pathName)
                                    }
                                }}
                                url={action.actionType === 'link' && action.url}
                                styleType={action.style}
                                isExternal={action.isExternal}
                            />
                        })
                    }
                </div>
            </InformationBanner>
        </React.Fragment>
    )
}

export default EducatorHomepage